import React from 'react';
import {Button, Menu} from "antd";
import {useAuth0} from "../../services/auth0";

const SignedUpLinks = () => {
    const {loginWithRedirect} = useAuth0();
    return (
        <Menu
            mode="horizontal"
            defaultSelectedKeys={['2']}
        >
            <Menu.Item key="1" onClick={() => loginWithRedirect({})}>Sign In</Menu.Item>
            <Menu.Item key="4"><a type="link" target="_blank" href="mailto:contact@paradi.io">Contact Us</a></Menu.Item>
        </Menu>
    )
};

export default SignedUpLinks;